var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip"},[_c('span',{staticClass:"tip-icon"},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_c('span',{staticClass:"tip-text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }